import React from 'react';
import './AdminRawThoughtTimeline.css';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

const AdminRawThoughtTimeline = ({ thoughts, onEdit, onDelete, onConvertToChapter, onConvertToArticle }) => {
    const formatDate = (dateString) => {
        return dayjs(dateString).tz('Asia/Kolkata').format('YYYY-MM-DD');
    };

    const formatTime = (dateString) => {
        return dayjs(dateString).tz('Asia/Kolkata').format('hh:mm A');
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'in_progress':
                return '#ff9800';
            case 'published':
                return '#4caf50';
            case 'archived':
                return '#9e9e9e';
            default:
                return '#2196f3';
        }
    };

    const getStatusLabel = (status) => {
        switch (status) {
            case 'in_progress':
                return 'In Progress';
            case 'published':
                return 'Published';
            case 'archived':
                return 'Archived';
            default:
                return status;
        }
    };

    const stripHtml = (html) => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || '';
    };

    const getContentPreview = (content) => {
        const text = stripHtml(content);
        return text.length > 100 ? text.substring(0, 100) + '...' : text;
    };

    const getAttachmentCount = (attachments) => {
        if (!attachments) return 0;
        try {
            const parsed = JSON.parse(attachments);
            return Array.isArray(parsed) ? parsed.length : 0;
        } catch {
            return 0;
        }
    };

    // Group thoughts by date
    const groupThoughtsByDate = () => {
        const groups = {};
        thoughts.forEach(thought => {
            const date = dayjs(thought.created_at).tz('Asia/Kolkata').format('YYYY-MM-DD');
            if (!groups[date]) {
                groups[date] = [];
            }
            groups[date].push(thought);
        });
        return groups;
    };

    const groupedThoughts = groupThoughtsByDate();

    return (
        <div className="raw-thoughts-timeline">
            {Object.entries(groupedThoughts).map(([date, dayThoughts]) => (
                <div key={date} className="timeline-day">
                    <div className="timeline-date-header">
                        <h3>{dayjs(date).tz('Asia/Kolkata').format('dddd, YYYY-MM-DD')}</h3>
                    </div>
                    
                    <div className="timeline-items">
                        {dayThoughts.map((thought, index) => {
                            const attachmentCount = getAttachmentCount(thought.attachments);
                            
                            return (
                                <div key={thought.id} className="timeline-item">
                                    <div className="timeline-marker">
                                        <div className="timeline-time">
                                            {formatTime(thought.created_at)}
                                        </div>
                                        <div className="timeline-dot"></div>
                                    </div>
                                    
                                    <div className="timeline-content">
                                        <div className="timeline-header">
                                            <h4 className="timeline-title">{thought.title}</h4>
                                        </div>
                                        
                                        <div className="timeline-meta">
                                            <div className="meta-item">
                                                <span className="material-icons">category</span>
                                                <span>{thought.category || 'No Category'}</span>
                                            </div>
                                            {attachmentCount > 0 && (
                                                <div className="meta-item">
                                                    <span className="material-icons">attach_file</span>
                                                    <span>{attachmentCount} attachment{attachmentCount !== 1 ? 's' : ''}</span>
                                                </div>
                                            )}
                                            {thought.author_name && (
                                                <div className="meta-item">
                                                    <span className="material-icons">person</span>
                                                    <span>{thought.author_name}</span>
                                                </div>
                                            )}
                                        </div>
                                        
                                        {thought.tags && (
                                            <div className="timeline-tags">
                                                {thought.tags.split(',').map((tag, tagIndex) => (
                                                    <span key={tagIndex} className="tag">
                                                        {tag.trim()}
                                                    </span>
                                                ))}
                                            </div>
                                        )}
                                        
                                        <div className="timeline-preview">
                                            <p>{getContentPreview(thought.content)}</p>
                                        </div>
                                        
                                        <div className="timeline-actions">
                                            <button
                                                onClick={() => onEdit(thought)}
                                                className="action-btn edit-btn"
                                                title="Edit thought"
                                            >
                                                <span className="material-icons">edit</span>
                                            </button>
                                            <button
                                                onClick={() => onDelete(thought.id)}
                                                className="action-btn delete-btn"
                                                title="Delete thought"
                                            >
                                                <span className="material-icons">delete</span>
                                            </button>
                                            <button
                                                onClick={() => onConvertToChapter(thought)}
                                                className="action-btn convert-btn"
                                                title="Add to Book (Convert to Chapter)"
                                                style={{ marginLeft: 8 }}
                                            >
                                                <span className="material-icons">auto_stories</span>
                                            </button>
                                            <button
                                                onClick={() => onConvertToArticle(thought)}
                                                className="action-btn"
                                                title="Convert to Article"
                                                style={{ marginLeft: 8 }}
                                            >
                                                <span className="material-icons">article</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default AdminRawThoughtTimeline; 